// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-table-pdfDetails {
	width: 100%;
	margin-bottom: 20px;
	font-size: 14px;
	border-collapse: collapse;
	border-radius: 12px;
	border-style: hidden;
	box-shadow: 0 0 0 2px #8e8e8e;
}

.custom-table-pdfDetails tbody {
	text-align: center;
}

.custom-table-pdfDetails th,
.custom-table-pdfDetails td {
	border: 2px solid #8e8e8e;
	padding: 8px;
}

.custom-table-pdfDetails th {
	color: #8e8e8e;
	width: 50%;
}
`, "",{"version":3,"sources":["webpack://./src/utils/stamp-denominations.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,mBAAmB;CACnB,eAAe;CACf,yBAAyB;CACzB,mBAAmB;CACnB,oBAAoB;CACpB,6BAA6B;AAC9B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;;CAEC,yBAAyB;CACzB,YAAY;AACb;;AAEA;CACC,cAAc;CACd,UAAU;AACX","sourcesContent":[".custom-table-pdfDetails {\n\twidth: 100%;\n\tmargin-bottom: 20px;\n\tfont-size: 14px;\n\tborder-collapse: collapse;\n\tborder-radius: 12px;\n\tborder-style: hidden;\n\tbox-shadow: 0 0 0 2px #8e8e8e;\n}\n\n.custom-table-pdfDetails tbody {\n\ttext-align: center;\n}\n\n.custom-table-pdfDetails th,\n.custom-table-pdfDetails td {\n\tborder: 2px solid #8e8e8e;\n\tpadding: 8px;\n}\n\n.custom-table-pdfDetails th {\n\tcolor: #8e8e8e;\n\twidth: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
